import { Button } from "@mui/material";
import useLogin from "../libs/login/useLogin";
import { AccountCircleOutlined } from "@mui/icons-material";

export default function LoginButton(){
    const {login} = useLogin()
    return <Button variant="contained" color="primary" startIcon={<AccountCircleOutlined/>} onClick={e => login()}>Login</Button>
}